import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { getProps } from "./components/DrupalView/utils.js";

const PhotoGallery = React.lazy(() => import("./components/PhotoGallery.jsx"));
const photoGalleries = [
	...document.querySelectorAll('[data-inject="PhotoGallery"]'),
];
if (photoGalleries.length) {
	photoGalleries.forEach((galleryNode) => {
		const images = JSON.parse(galleryNode.dataset.props) || [];
		ReactDOM.render(
			<Suspense fallback={<div>Loading gallery...</div>}>
				<PhotoGallery images={images} />
			</Suspense>,
			galleryNode
		);
	});
}

const DrupalView = React.lazy(() =>
	import("./components/DrupalView/index.jsx")
);
const drupalViews = [
	...document.querySelectorAll('[data-inject="DrupalView"]'),
];
if (drupalViews.length) {
	drupalViews.forEach((view) => {
		const props = getProps(view);

		ReactDOM.render(
			<Suspense fallback={<div>Loading view...</div>}>
				<DrupalView {...props} />
			</Suspense>,
			view
		);
	});
}

const Schedule = React.lazy(() => import("./components/Schedule/index.jsx"));
const schedules = [...document.querySelectorAll('[data-inject="Schedule"]')];
if (schedules.length) {
	schedules.forEach((schedule) => {
    const props = JSON.parse(schedule.getAttribute("data-props"));
		ReactDOM.render(
			<Suspense fallback={<div>Loading schedule...</div>}>
				<Schedule {...props} />
			</Suspense>,
			schedule
		);
	});
}


const AtaeSchedule = React.lazy(() => import("./components/AtaeSchedule/index.jsx"));
const ataeschedules = [...document.querySelectorAll('[data-inject="AtaeSchedule"]')];
if (ataeschedules.length) {
  ataeschedules.forEach((schedule) => {
    const props = JSON.parse(schedule.getAttribute("data-props"));
    ReactDOM.render(
      <Suspense fallback={<div>Loading schedule...</div>}>
        <AtaeSchedule {...props} />
      </Suspense>,
      schedule
    );
  });
}

const CarouselWrapper= React.lazy(() => import("./components/CarouselWrapper.jsx"));

const carousels = [...document.querySelectorAll('[data-inject="Carousel"]')];
if (carousels.length) {
	carousels.forEach((carouselNode) => {
		// don't turn show-all-cards into carousel
		if (carouselNode.closest(".show-all-cards")) {
			return;
		}
		const carouselHTML = [...carouselNode.querySelectorAll(":scope > *")];
		ReactDOM.render(
			<Suspense fallback={<div>Loading carousel...</div>}>
				<CarouselWrapper carouselHTML={carouselHTML} />
			</Suspense>,
			carouselNode
		);
	});
}

const SimpleCarouselWrapper = React.lazy(() => import("./components/SimpleCarouselWrapper.jsx"));

const testimonials = [...document.querySelectorAll('[data-inject="Testimonials"]')];
if (testimonials.length) {
	testimonials.forEach((simpleCarouselNode) => {

		const simpleCarouselHTML = [...simpleCarouselNode.querySelectorAll(":scope > div > *")];
		const autoscroll = simpleCarouselNode.classList.contains('carousel-autoscroll');
		ReactDOM.render(
			<Suspense fallback={<div>Loading simpleCarousel...</div>}>
				<SimpleCarouselWrapper simpleCarouselHTML={simpleCarouselHTML} autoscroll={autoscroll} />
			</Suspense>,
			simpleCarouselNode
		);
	});
}

const latestContent = [...document.querySelectorAll('[data-inject="LatestContent"]')];
if (latestContent.length) {
	latestContent.forEach((simpleCarouselNode) => {

		const simpleCarouselHTML = [...simpleCarouselNode.querySelectorAll(":scope > *")];
		ReactDOM.render(
			<Suspense fallback={<div>Loading simpleCarousel...</div>}>
				<SimpleCarouselWrapper simpleCarouselHTML={simpleCarouselHTML} />
			</Suspense>,
			simpleCarouselNode
		);
	});
}

const CommiteeKeyMembers = React.lazy(() => import('./components/DrupalView/CommitteeKeyMembers.jsx'));
const keyATAEMembers = [...document.querySelectorAll('[data-inject="ATAEKeyMembers"]')];
if(keyATAEMembers.length) {
	keyATAEMembers.forEach((el) => {
		ReactDOM.render(
			<Suspense fallback={<div>Loading...</div>}>
				<CommiteeKeyMembers />
			</Suspense>,
			el
		);
	})
}
